import { apiSlice } from "../../api/apiSlice";

// CONSTANTS
const DEPARTMENTS_URL = "api/departments";
const CAREERS_URL = "api/allCareers";
const CAREERS_OF_DEPARTMENT_URL = "api/careersOfDepartment";
const CAREER_BY_ID_URL = "api/getCareerDetails";
const DIRECT_EMPLOYEE_URL = "api/directEmployee";
const EMPLOYEE_URL = "api/employee";

// ################### CAREERS API SLICE ###################
export const careersApiSlice = apiSlice.injectEndpoints({
   endpoints: (builder) => ({
      getDepartments: builder.query({
         query: () => DEPARTMENTS_URL,
      }),
      getAllCareers: builder.query({
         query: () => CAREERS_URL,
         transformResponse: (responseData) => {
            return responseData?.data?.sort(
               (a, b) => new Date(b.created_at) - new Date(a.created_at)
            );
         },
      }),
      getCareersByDepartment: builder.query({
         query: (departmentID) =>
            `${CAREERS_OF_DEPARTMENT_URL}/${departmentID}`,
         transformResponse: (responseData) => {
            return responseData?.data?.sort(
               (a, b) => new Date(b.created_at) - new Date(a.created_at)
            );
         },
      }),
      getCareerById: builder.query({
         query: (careerID) => `${CAREER_BY_ID_URL}/${careerID}`,
      }),
      createDirectEmployee: builder.mutation({
         query: (employeeInfo) => {
            return {
               url: DIRECT_EMPLOYEE_URL,
               method: "POST",
               body: employeeInfo,
               formData: true,
            };
         },
      }),
      createEmployee: builder.mutation({
         query: (employeeInfo) => {
            return {
               url: EMPLOYEE_URL,
               method: "POST",
               body: employeeInfo,
               formData: true,
            };
         },
      }),
   }),
});

export const {
   useGetDepartmentsQuery,
   useGetAllCareersQuery,
   useGetCareersByDepartmentQuery,
   useGetCareerByIdQuery,
   useCreateDirectEmployeeMutation,
   useCreateEmployeeMutation,
} = careersApiSlice;
